const text = `個人資料同意書

立格科技股份有限公司(以下稱本公司) 依據個人資料保護法規定，告知下列關於個人資料蒐集之目的、類別、利用範圍及方式、以及您所得行使之權利等事項，請您詳閱。

一、	個人資料蒐集之目的與類別
(1)	本公司為提供商品服務、電子商務服務、售後服務、履行法定或合約義務、保護當事人及相關利害關係人之權益、行銷、客戶管理與服務、以及經營合於營業登記項目或組織章程所定之業務等目的所需，依照各服務屬性，蒐集您的姓名、連絡方式 (包括但不限於電話、E-MAIL及地址等) 及其他得以直接或間接識別使用者身份之個人資料。
(2)	客戶同意並知悉本公司基於服務及履行相關承諾時，得蒐集、處理及利用客戶個人資料（包括但不限於行銷推廣、網路購物及其他電子商務服務、廣告或商業行為管理、快遞、客戶滿意度調查等服務）。

二、	個人資料利用之期間、地區、對象及方式
(1)	個人資料的利用
本公司所蒐集足以識別使用者身份的個人資料、消費與交易資料，或日後經您同意而提供之其他個人資料，都僅供本公司於其內部或策略合作廠商、依照蒐集之目的進行處理和利用、或為完成提供服務或履行合約義務之必要、或依照相關法令規定或有權主管機關（包括但不限於法院或台灣票據交換所）之命令或要求，否則本公司不會將足以識別使用者身份的個人資料提供給第三人（包括境內外）、或移作蒐集目的以外之使用。 本公司會持續保管、處理及利用相關資料。在上開蒐集目的範圍內，本公司會將所蒐集的個人資料，提供予合作廠商（包括但不限提供本服務之宅配貨運業者或其他）以協助交易完成或終止。
(2)	期間：本公司因執行業務所必須之期間。
(3)	對象：本公司及有合作或業務往來之企業機構、合作廠商、及依法有調查權機關。
(4)	地區：中華民國境內、境外（主管機關禁止者不在此限）。
(5)	方式：任何依法規定得利用之方式。

三、	客戶就本公司保有客戶之個人資料得行使的權利及方式
客戶得依個人資料保護法第三條規定，以書面、電話、傳真、電子文件或其他適當方式
(1)	請求向本公司查詢或閱覽。
(2)	請求向本公司製給複製本。 
(3)	請求向本公司補充或更正，惟依法須請您適當之釋明。 
(4)	請求向本公司停止蒐集、處理或利用及刪除的權利。

四、	個人資料之提供及所致權益之影響
您得自由選擇是否提供相關個人資料，惟您若拒絕提供相關個人資料，本公司將無法進行必要之審核及處理作業，致無法提供您相關服務。

五、	個人資料之保密
本公司將善盡個人資料保護之責。如因天災、事變或其他不可抗力所致者，致您的個人資料被竊取、洩漏、竄改、遭其他侵害者，本公司將於查明後以電話、電子郵件或網站公告等方法，擇適當方式通知您。

六、	同意書之效力
當您完成簽署時，即表示您已閱讀瞭解並同意本同意書的內容，本公司保留隨時修改本同意書之權利，內容修改時將於本公司網站公告。如您未於公告後一個月內提出異議或仍繼續使用本館相關服務，將視為您已同意並接受本館所更改之內容。
`;

export default text;
